import type { HelpFile } from '../../types/help'
import { DesignerToolbarTestIds } from '../../../testids/DesignerToolbarTestIds'

export const designerToolbarHelp: HelpFile = {
  docPage: '/docs/admin/form-layout-designer',
  texts: {
    [DesignerToolbarTestIds.designerToolbarTitle]: null,
    [DesignerToolbarTestIds.designerPreviewBtn]:
      'Switch to preview mode to see how the layout renders in the app.',
  },
}
